// extracted by mini-css-extract-plugin
export default {"secondary-cta":"secondary-cta--mp-AX9oZ","secondaryCta":"secondary-cta--mp-AX9oZ"};